
import React from 'react';
import { Building2, Plus, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyStateLayout } from './EmptyStateLayout';

interface ClientsEmptyStateProps {
  onAddClient?: () => void;
}

export const ClientsEmptyState: React.FC<ClientsEmptyStateProps> = ({ onAddClient }) => {
  return (
    <EmptyStateLayout
      icon={Building2}
      title="No Clients Yet"
      description="Start managing your client relationships by adding your first client."
    >
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-4">
        <Button onClick={onAddClient}>
          <Plus className="h-4 w-4 mr-2" />
          Add Client
        </Button>
        <Button variant="outline">
          <Upload className="h-4 w-4 mr-2" />
          Import Clients
        </Button>
      </div>
      <div className="mt-6 text-sm text-muted-foreground">
        <p className="mb-2">Client management features:</p>
        <ul className="text-left max-w-md mx-auto space-y-1">
          <li>• Track client interactions and history</li>
          <li>• Monitor job requirements and feedback</li>
          <li>• Manage contract terms and revenue</li>
        </ul>
      </div>
    </EmptyStateLayout>
  );
};
